module.exports = "<app-package-list></app-package-list>"